import React from "react";
import { Box, Typography, Avatar, Grid, ListItem, List, Tooltip, capitalize } from "@mui/material";
import RectangleIcon from "@mui/icons-material/Rectangle";
import moment from "moment";
import { useNavigate } from "react-router-dom";

interface AIAgentRequestsTableProps {
    aiAgents: any[];
    resourceStatuses: any[];
}

const AIAgentRequestsTable: React.FC<AIAgentRequestsTableProps> = ({
    aiAgents, 
    resourceStatuses
}: AIAgentRequestsTableProps) => {
    const [cardHoverIndex, setCardHoverIndex] = React.useState<number | null>(null);
    const navigate = useNavigate();
        
    return (
        <List sx={{ bgcolor: "#fafafa" }}>
            <ListItem sx={{ bgcolor: "#f2f2f2", borderRadius: "4px" }}>
                <Box width="100%">
                    <Grid container direction="row" alignItems="center">
                        <Grid item xs={2}><Typography fontSize="12px">AGENT NAME</Typography></Grid>
                        <Grid item xs={1.25}><Typography fontSize="12px">APPLICATION</Typography></Grid>
                        <Grid item xs={1.25}><Typography fontSize="12px">CLOUD PROVIDER</Typography></Grid>
                        <Grid item textAlign="start" xs={1.5}><Typography fontSize="12px">OWNER</Typography></Grid>
                        <Grid item xs={1}><Typography fontSize="12px">GPU</Typography></Grid>
                        <Grid item xs={1.25}><Typography fontSize="12px">MODEL</Typography></Grid>
                        <Grid item textAlign="start" xs={1.25}><Typography fontSize="12px">REQUESTED ON</Typography></Grid>
                        <Grid textAlign="start" item xs={1.5}><Typography fontSize="12px">ACTIONED BY/ REASON</Typography></Grid>
                        <Grid item textAlign="start" xs={1}><Typography fontSize="12px">ACTIONED ON</Typography></Grid>
                    </Grid>
                </Box>
            </ListItem>
            {aiAgents.map((agent: any, index: number) => (
                <ListItem
                    key={agent.id}
                    sx={{
                        border: cardHoverIndex === index ? "1px solid #000" : "1px solid #00000000",
                        mt: 1,
                        cursor: "pointer",
                        bgcolor: agent.status === "active" || agent.status === "approved" ? "#FFFFFF" : agent.status === "rejected" ? "#F0443810" : "#FDB02210",
                        borderRadius: "8px",
                    }}
                    onClick={() => {
                        navigate(`/aisolutions/requests/aiagent/${agent.id}`);
                    }}
                    onMouseEnter={() => setCardHoverIndex(index)}
                    onMouseLeave={() => {
                        setCardHoverIndex(null);
                    }}
                >
                    <Box width="100%" sx={{}}>
                        <Grid container direction="row" alignItems="center" justifyContent="space-between">
                            <Grid item xs={2}>
                                {
                                    <Box sx={{ display: "flex", alignItems: "center" }}>
                                        <RectangleIcon sx={{ color: agent.status === "active" || agent.status === "approved" ? "#12B76A" : agent.status === "rejected" ? "#F04438" : "#FDB022", bgcolor: agent.status === "active" || agent.status === "approved" ? "#12B76A" : agent.status === "rejected" ? "#F04438" : "#FDB022", width: "4px", marginRight: "8px", }} />
                                        <Typography fontSize="14px" fontFamily="Gilroy-Medium">{agent.agentName}</Typography>
                                        {(agent.status === 'active' || agent.status === 'approved') && resourceStatuses && resourceStatuses.length > 0 ? ( 
                                            <Tooltip sx={{ whiteSpace: "pre-line" }} title={ <Box key={`${agent.id}-tooltip`}>Current Status<br />{resourceStatuses.filter((e:any) => e.resourceId === agent.id).map((e: any, i: number) => ( <React.Fragment key={`${agent.id}-status-${i}`}>{capitalize(e.currentStatus)}<br /></React.Fragment> ))}</Box> }>
                                                <Avatar src="/assets/info.svg" alt="info" sx={{ height: 16, width: 16, marginLeft: "4px" }} />
                                            </Tooltip>
                                        ) : null}
                                    </Box>
                                }
                            </Grid>
                             <Grid item xs={1.25}>
                                <Typography fontSize="14px" fontFamily="Gilroy-Regular">{agent.applicationName || 'N/A'}</Typography>
                            </Grid>
                            <Grid item xs={1.25}>
                                <Typography fontSize="14px" fontFamily="Gilroy-Regular" sx={{textTransform: 'uppercase'}}>{agent.cloudProvider || 'N/A'}</Typography>
                            </Grid>
                            <Grid item xs={1.5}>
                                {
                                    <Box sx={{ display: "flex", alignItems: "center" }}>
                                        <Avatar src={agent.aIAgentOwnerAvatar} alt={agent.aIAgentOwnerName} sx={{ marginRight: "8px", height: 30, width: 30 }}>{agent.aIAgentOwnerName ? agent.aIAgentOwnerName.charAt(0).toUpperCase() : ''}</Avatar>
                                        <Typography fontSize="14px" fontFamily="Gilroy-Regular">{agent.aIAgentOwnerName}</Typography>
                                    </Box>
                                }
                            </Grid>
                             <Grid item xs={1}>
                                <Typography fontSize="14px" fontFamily="Gilroy-Regular">{agent.gpu || 'N/A'}</Typography>
                            </Grid>
                            <Grid item xs={1.25}>
                                <Typography fontSize="14px" fontFamily="Gilroy-Regular">{agent.modelName || 'N/A'}</Typography>
                            </Grid>
                            <Grid item xs={1.25}>
                                {
                                    <Box display="flex" alignItems="center">
                                        <Typography fontSize="14px" fontFamily="Gilroy-Regular">{agent.createdAt ? moment(agent.createdAt).format("DD/MM/YYYY | hh:mm A") : 'N/A'}</Typography>
                                    </Box>
                                }
                            </Grid>
                            <Grid item xs={1.5}>
                                {agent.status !== "pending" && (
                                    <Box sx={{ display: "flex", alignItems: "center" }}>
                                        {agent.aIAgentApproverName &&
                                            <Avatar alt={agent.aIAgentApproverName} sx={{ marginRight: "8px", height: 30, width: 30 }}>{agent.aIAgentApproverName.charAt(0).toUpperCase()}</Avatar>
                                        }
                                        {agent.aIAgentApproverName &&
                                            <Typography fontSize="14px" fontFamily="Gilroy-Regular" mr={1}>{agent.aIAgentApproverName}</Typography>
                                        }
                                        {agent.status === "rejected" && agent.reasonForRejection && (
                                            <Tooltip title={`Reason: ${agent.reasonForRejection}`}><img src="/assets/info.svg" alt="info" /></Tooltip>
                                        )}
                                    </Box>
                                )}
                            </Grid>
                            <Grid item xs={1}>
                                {(agent.status !== "pending" && agent.actionedAt) && (
                                    <Box display="flex" alignItems="center">
                                        <Typography fontSize="14px" fontFamily="Gilroy-Regular">{moment(agent.actionedAt).format("DD/MM/YYYY | hh:mm A")}</Typography>
                                    </Box>
                                )}
                            </Grid>
                        </Grid>
                    </Box>
                </ListItem>
            ))}
        </List>
    );
};

export default AIAgentRequestsTable;